import { render, staticRenderFns } from "./sendBack.vue?vue&type=template&id=09ec6e7e&scoped=true&"
import script from "./sendBack.vue?vue&type=script&lang=js&"
export * from "./sendBack.vue?vue&type=script&lang=js&"
import style0 from "./sendBack.vue?vue&type=style&index=0&module=true&lang=css&"
import style1 from "./sendBack.vue?vue&type=style&index=1&id=09ec6e7e&scoped=true&lang=css&"
import style2 from "./sendBack.vue?vue&type=style&index=2&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "09ec6e7e",
  null
  
)

export default component.exports